import { useEffect, useMemo, useState } from "react";
import { getVar } from "../../../../http/api/VarAPI";

/**
 * 販売原票一括入力　検索
 */
export const useDetailSelectOptions = () => {
  
  const [origins, setOrigins] = useState([]);
  const [ranks, setRanks] = useState([]);
  const [productClasses, setProductClasses] = useState([]);
  const [packings, setPackings] = useState([]);

  useEffect(() => {
    (async () => {
      await searchOrigins();
      await searchRanks();
      await searchProductClasses();
      await searchPackings();
    })();

  }, [])
  
  const searchOrigins = async () => {
    const originRes = await getVar({varDiv: 1});

    setOrigins(
      originRes.listVarInfo
        .filter((varInfo) => varInfo.varCd && varInfo.varValue1)
        .map((varInfo) => ({
          originId: varInfo.varCd,
          originName: varInfo.varValue1
        }))
    );
  }

  const searchRanks = async () => {
    const rankRes = await getVar({varDiv: 3});
    setRanks(
      rankRes.listVarInfo
        .filter((varInfo) => varInfo.varCd && varInfo.varValue1)
        .map((varInfo) => ({
          rankId: varInfo.varCd,
          rankName: varInfo.varValue1
        })
      )
    );
  }

  const searchProductClasses = async () => {
    const productClassRes = await getVar({varDiv: 2});
    setProductClasses(
      productClassRes.listVarInfo
        .filter((varInfo) => varInfo.varCd && varInfo.varValue1)
        .map((varInfo) => ({
          productClassId: varInfo.varCd,
          productClassName: varInfo.varValue1
        }))
    );
  };

  const searchPackings = async () => {
    const packingRes = await getVar({varDiv: 4});
    setPackings(
      packingRes.listVarInfo
        .filter((varInfo) => varInfo.varCd && varInfo.varValue1)
        .map((varInfo) => ({
          packingId: varInfo.varCd,
          packingName: varInfo.varValue1
        }))
    );
  };

  return useMemo(() => ({
    origins, ranks, productClasses, packings
  }), [origins, ranks, productClasses, packings]);
}


